import React, { useState } from "react";
import { getOnce, setData } from "../firebase/rtdb";

export default function CouponCreate() {
  const [couponCode, setCouponCode] = useState("");
  const [couponAmount, setCouponAmount] = useState("");
  const [couponScope, setCouponScope] = useState("all"); // all | shop
  const [shopId, setShopId] = useState("");
  const [type, setType] = useState("online"); // online | shop
  const [expireDate, setExpireDate] = useState("");
  const [message, setMessage] = useState("");

  const handleCreateCoupon = async () => {
    const code = couponCode.trim().toUpperCase();
    const amount = Number(couponAmount || 0);
    const allowedShop =
      couponScope === "all" ? "ALL" : shopId.trim().toUpperCase();

    if (!code || !amount || !expireDate) {
      setMessage("Please fill all required fields");
      return;
    }

    if (amount <= 0) {
      setMessage("Coupon amount must be greater than 0");
      return;
    }

    if (couponScope === "shop" && !allowedShop) {
      setMessage("Please enter shop ID for specific shop coupon");
      return;
    }

    try {
      const exists = await getOnce(`coupons/${code}`);

      if (exists) {
        setMessage(`Coupon code ${code} already exists`);
        return;
      }

      await setData(`coupons/${code}`, {
        code,
        shopId: allowedShop,
        scope: couponScope,
        amount,
        type,
        expireDate,

        used: false,
        usedByShop: "",
        voucherNo: "",
        usedAt: "",

        approved: true,
        createdAt: new Date().toISOString(),
      });

      setMessage(`✅ Coupon ${code} created successfully`);

      setCouponCode("");
      setCouponAmount("");
      setShopId("");
      setCouponScope("all");
      setType("online");
      setExpireDate("");
    } catch (err) {
      console.error(err);
      setMessage("❌ Error creating coupon. Check console.");
    }
  };

  return (
    <div className="coupon-create-container">
      <h2>Create Coupon</h2>

      <div className="form-group">
        <label>Coupon Type</label>
        <select value={type} onChange={(e) => setType(e.target.value)}>
          <option value="online">Online Coupon</option>
          <option value="shop">Shop Coupon</option>
        </select>
      </div>

      <div className="form-group">
        <label>Coupon Usage Scope</label>
        <select
          value={couponScope}
          onChange={(e) => {
            setCouponScope(e.target.value);
            if (e.target.value === "all") {
              setShopId("");
            }
          }}
        >
          <option value="all">All Shops</option>
          <option value="shop">Specific Shop Only</option>
        </select>
      </div>

      {couponScope === "all" && (
        <div className="coupon-scope-note">
          ✅ This coupon can be used at all shops one time only.
        </div>
      )}

      {couponScope === "shop" && (
        <div className="form-group">
          <label>Allowed Shop ID</label>
          <input
            type="text"
            value={shopId}
            onChange={(e) => setShopId(e.target.value.toUpperCase())}
            placeholder="Ex: OSHT"
          />
        </div>
      )}

      <div className="form-group">
        <label>Coupon Code</label>
        <input
          type="text"
          value={couponCode}
          onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
          placeholder="Ex: OSHT-001"
        />
      </div>

      <div className="form-group">
        <label>Coupon Amount</label>
        <input
          type="number"
          value={couponAmount}
          onChange={(e) => setCouponAmount(e.target.value)}
          placeholder="10000"
        />
      </div>

      <div className="form-group">
        <label>Expiration Date</label>
        <input
          type="date"
          value={expireDate}
          onChange={(e) => setExpireDate(e.target.value)}
        />
      </div>

      <button type="button" onClick={handleCreateCoupon} className="create-btn">
        Create Coupon
      </button>

      {message && <p className="message">{message}</p>}
    </div>
  );
}